import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import { outlinedFieldSx, searchIconSx } from "../../utils/fieldStyles";

type TextFieldComponentProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  showSearchIcon?: boolean;
};

export default function TextFieldComponent({
  label,
  onChange,
  value,
  showSearchIcon
}: TextFieldComponentProps) {
  const [valueInternal, setValue] = useState<string>(value);

  const handleOnChange = (event: any) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    if (!value) setValue("");
  }, [value]);

  useEffect(() => {
    if (!valueInternal) return onChange("");
    const timeoutId = setTimeout(() => onChange(valueInternal), 500);
    return () => clearTimeout(timeoutId);
  }, [valueInternal]);

  return (
    <TextField
      placeholder={label}
      variant="outlined"
      value={valueInternal}
      onChange={handleOnChange}
      fullWidth
      InputProps={
        showSearchIcon
          ? {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={searchIconSx} />
                </InputAdornment>
              )
            }
          : undefined
      }
      sx={outlinedFieldSx}
    />
  );
}
